import styled from 'styled-components';

export const ICON_SCALE = 0.78125;

export const StyledInputValidationIconWrapper = styled.span`
  position: absolute;
  top: 0.9375rem;
  right: 0.8125rem;
`;
